import { defineStore } from 'pinia';

export const usePlanStore = defineStore('planStore', {
    state: () => {
        return {
            plan_type: 'day',
            plans: [{}],
        }
    },
    persist: {
        pick: ['plan_type', 'plans']
    },
    getters: {
        validationMessage: (state) => {
            let message = "";

            const emptyPlans = state.plans.filter(plan => {
                return !plan.id;
            });

            if (emptyPlans.length > 0) {
                message += "Please select a plan.<br>";
            }

            return message;
        },
    },
    actions: {
        setPlanType(payload) {
            this.plan_type = payload.type;
        },
        setPlans(payload) {
            this.plans = payload.plans;
        },
        setPlanByIndex(payload) {
            this.plans[payload.index] = payload.plan;
        },
        pushPlan(payload) {
            this.plans.push(payload.plan);
        },
        popPlan() {
            if (this.plans.length > 1) {
                this.plans.pop();
            }
        },
    }
});